import { render, staticRenderFns } from "./SalesOrderDisplayDialog.vue?vue&type=template&id=27796b85"
import script from "./SalesOrderDisplayDialog.vue?vue&type=script&lang=js"
export * from "./SalesOrderDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports